import { createRouter, createWebHistory } from 'vue-router'
import Login from "@/views/Login";
import Layout from "@/views/Layout";

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/role2',
    name: 'role2',
    component: () => import('@/views/system/Role')
  },
  {
    path: '/',
    name: 'home',
    component: Layout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
          title: '首页',
        },
        component: () => import('@/views/Dashboard')
      },
      {
        path: '/platform/apps/mgr',
        name: 'app',
        meta: {
          title: '应用管理',
        },
        component: () => import('@/views/admin/App')
      },
      {
        path: '/tenant/users',
        name: 'adminUser',
        meta: {
          title: '用户列表',
        },
        component: () => import('@/views/admin/AdminUser')
      },
      {
        path: '/tenant/wxpay',
        name: 'wxPay',
        meta: {
          title: '支付配置',
        },
        component: () => import('@/views/admin/WxPay')
      },
      {
        path: '/om/coupon',
        name: 'coupon',
        meta: {
          title: '优惠券',
        },
        component: () => import('@/views/marketing/Coupon')
      },
      {
        path: '/mall/prod/group',
        name: 'group',
        meta: {
          title: '商品分组',
        },
        component: () => import('@/views/product/Group')
      },
      {
        path: '/mall/prod/category',
        name: 'category',
        meta: {
          title: '商品分类',
        },
        component: () => import('@/views/product/Category')
      },
      {
        path: '/mall/balance/gift',
        name: 'redPacket',
        meta: {
          title: '红包明细',
        },
        component: () => import('@/views/report/RedPacket')
      },
      {
        path: '/report/promotion',
        name: 'inviteDetail',
        meta: {
          title: '推荐明细',
        },
        component: () => import('@/views/report/InviteDetail')
      },
      {
        path: '/report/promotion/summary',
        name: 'inviteSum',
        meta: {
          title: '推荐汇总',
        },
        component: () => import('@/views/report/InviteSum')
      },
      {
        path: '/report/order/per-summary',
        name: 'orderSum',
        meta: {
          title: '订单汇总',
        },
        component: () => import('@/views/report/OrderSum')
      },
      {
        path: '/om/commission',
        name: 'commissionDetail',
        meta: {
          title: '感谢礼明细',
        },
        component: () => import('@/views/finance/CommissionDetail')
      },
      {
        path: '/om/finance/transaction',
        name: 'financialDetail',
        meta: {
          title: '资金明细',
        },
        component: () => import('@/views/finance/FinancialDetail')
      },
      {
        path: '/setting',
        name: 'params',
        meta: {
          title: '系统参数',
        },
        component: () => import('@/views/setting/Params')
      },
      {
        path: '/mall/om/weaop',
        name: 'wxGzh',
        meta: {
          title: '公众号配置',
        },
        component: () => import('@/views/setting/WxGzh')
      },
      {
        path: '/setting/wechat',
        name: 'wxValid',
        meta: {
          title: '校验文件',
        },
        component: () => import('@/views/setting/WxValid')
      },
      {
        path: '/om/commission/config',
        name: 'commissionConfig',
        meta: {
          title: '感谢礼规则',
        },
        component: () => import('@/views/setting/CommissionConfig')
      },
      {
        path: '/customer-service/phone',
        name: 'customerService',
        meta: {
          title: '客服电话',
        },
        component: () => import('@/views/setting/CustomerService')
      },
      {
        path: '/om/benefit',
        name: 'benefit',
        meta: {
          title: '权益礼包',
        },
        component: () => import('@/views/marketing/Benefit')
      },
      {
        path: '/om/reward',
        name: 'rewardConfig',
        meta: {
          title: '奖励配置',
        },
        component: () => import('@/views/marketing/RewardConfig')
      },
      {
        path: '/om/orders',
        name: 'order',
        meta: {
          title: '订单列表',
        },
        component: () => import('@/views/order/Order')
      },
      {
        path: '/om/salt/service',
        name: 'afterSale',
        meta: {
          title: '售后管理',
        },
        component: () => import('@/views/order/AfterSale')
      },
      {
        path: '/om/salt/address',
        name: 'backAddress',
        meta: {
          title: '退货地址',
        },
        component: () => import('@/views/setting/BackAddress')
      },
      {
        path: '/mall/om/notification/config',
        name: 'noticeConfig',
        meta: {
          title: '通知规则',
        },
        component: () => import('@/views/setting/NoticeConfig')
      },
      {
        path: '/mall/prods',
        name: 'spu',
        meta: {
          title: '商品列表',
        },
        component: () => import('@/views/product/Spu')
      },
      {
        path: '/spu/create',
        name: 'spuCreate',
        meta: {
          title: '发布商品',
        },
        component: () => import('@/views/product/SpuCreate')
      },
      {
        path: '/om/users',
        name: 'memberUser',
        meta: {
          title: '用户列表',
        },
        component: () => import('@/views/member/MemberUser')
      },
      {
        path: '/om/point',
        name: 'scoreDetail',
        meta: {
          title: '返现明细',
        },
        component: () => import('@/views/report/ScoreDetail')
      },
      {
        path: '/mall/delivery-tc-config',
        name: 'cityDelivery',
        meta: {
          title: '同城配送',
        },
        component: () => import('@/views/setting/CityDelivery')
      },
      {
        path: '/page/index/pop',
        name: 'indexPop',
        meta: {
          title: '首页弹窗',
        },
        component: () => import('@/views/page/IndexPop')
      },
      {
        path: '/mall/page/config',
        name: 'page',
        meta: {
          title: '页面列表',
        },
        component: () => import('@/views/page/Page')
      },
      {
        path: '/report/detail',
        name: 'orderDetail',
        meta: {
          title: '销售明细',
        },
        component: () => import('@/views/report/OrderDetail')
      },
      {
        path: '/om/vip/types',
        name: 'vipType',
        meta: {
          title: '会员类型',
        },
        component: () => import('@/views/marketing/VipType')
      },
      {
        path: 'vip/benefit/package',
        name: 'vipBenefit',
        meta: {
          title: '会员权益',
        },
        component: () => import('@/views/marketing/VipBenefit')
      },
      {
        path: 'mall/barcodes',
        name: 'standardSpu',
        meta: {
          title: '标准商品库',
        },
        component: () => import('@/views/product/StandardSpu')
      },
      {
        path: '/mall/traceability/group',
        name: 'articleGroup',
        meta: {
          title: '文章分组',
        },
        component: () => import('@/views/product/ArticleGroup')
      },
      {
        path: '/mall/traceability',
        name: 'traceability',
        meta: {
          title: '产品溯源',
        },
        component: () => import('@/views/product/Traceability')
      },
      {
        path: '/mall/time',
        name: 'bizHours',
        meta: {
          title: '营业时间',
        },
        component: () => import('@/views/setting/BizHours')
      },
      {
        path: '/doc/agreements',
        name: 'agreement',
        meta: {
          title: '服务协议',
        },
        component: () => import('@/views/setting/Agreement')
      },
      {
        path: '/doc/privacy',
        name: 'privacy',
        meta: {
          title: '隐私政策',
        },
        component: () => import('@/views/setting/Privacy')
      },
      {
        path: '/om/commission/history',
        name: 'commissionLog',
        meta: {
          title: '感谢礼明细',
        },
        component: () => import('@/views/order/CommissionLog')
      },
      {
        path: '/om/commission/fee',
        name: 'commission',
        meta: {
          title: '感谢礼管理',
        },
        component: () => import('@/views/order/Commission')
      },
      {
        path: '/om/order/vip',
        name: 'vipOrder',
        meta: {
          title: '会员订单',
        },
        component: () => import('@/views/order/VipOrder')
      },
      {
        path: '/om/point/rule',
        name: 'pointRule',
        meta: {
          title: '返现规则',
        },
        component: () => import('@/views/order/PointRule')
      },
      {
        path: '/om/transport/template',
        name: 'shippingTemplate',
        meta: {
          title: '运费模板',
        },
        component: () => import('@/views/setting/ShippingTemplate')
      },
      {
        path: '/setting/pickup',
        name: 'pickup',
        meta: {
          title: '自提门店',
        },
        component: () => import('@/views/setting/Pickup')
      },
      {
        path: '/om/order/writenoff',
        name: 'offlineOrder',
        meta: {
          title: '线下核销',
        },
        component: () => import('@/views/order/OfflineOrder')
      },
      {
        path: '/supplier',
        name: 'supplier',
        meta: {
          title: '供应商管理',
        },
        component: () => import('@/views/product/Supplier')
      },
      {
        path: '/balance',
        name: 'balance',
        meta: {
          title: '金豆福豆',
        },
        component: () => import('@/views/order/Balance')
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
